import { Injectable, inject } from '@angular/core';

import { type ICmsStoredPage, SitePagesApiService } from '@rt-tools/cms-angular/site';

import type { IBlogArticle } from './blog-article.types';

// Тип страниц CMS, из которых собран блог.
const BLOG_CONTENT_TYPE: string = 'blog-articles';

// Статья для страницы: сама статья и языки, на которых опубликован её адрес.
export interface IStoredBlogArticle {
    readonly article: IBlogArticle.State;
    readonly locales: readonly string[];
}

// Статьи блога из публичной выдачи CMS. Читает их клиент пакета: страницу блога рисует сервер
// сайта, и прочитанное им едет в браузер вместе со страницей, а черновик по токену не едет. Сервер
// CMS не ответил — список статей пуст, а статья считается несуществующей.
@Injectable()
export class BlogArticlesApiService {
    readonly #pages: SitePagesApiService = inject(SitePagesApiService);

    public published(locale: string): Promise<readonly IBlogArticle.State[]> {
        return this.#pages.published(BLOG_CONTENT_TYPE, locale);
    }

    public async article(slug: string, locale: string, previewToken: string = ''): Promise<IStoredBlogArticle | null> {
        const stored: ICmsStoredPage | null = await this.#pages.page(slug, locale, previewToken);

        return stored === null ? null : { article: stored.page, locales: stored.locales };
    }

    public tags(): Promise<readonly IBlogArticle.Tag[]> {
        return this.#pages.tags();
    }
}
